var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIxLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "img",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56.51 75.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.81,3.52l1.41,1.41V22.69l-.18,.29c-1.21,1.89-6.66,12.11-12.22,22.9-3.62,7.01-6.62,12.97-6.91,13.69-1.09,2.68-1.21,5.66-.32,8.41,.72,2.17,2.08,4.08,3.91,5.46,1.37,.88,2.92,1.44,4.53,1.63,.6,.09,1.85,.1,19.1,.1s18.49,0,19.1-.1c1.61-.19,3.16-.75,4.53-1.63,1.83-1.38,3.19-3.29,3.91-5.46,.81-2.49,.79-5.17-.05-7.64-.52-1.56-3.69-8.34-8.97-19.23-4.05-8.35-6.19-12.82-7.9-16.59l-.81-1.79V4.93l1.41-1.41c0-2.77,.28-3.52-10.32-3.52-11.04,0-10.21,.49-10.21,3.52Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75,3.91l1.42,1.42V23.22l-.18,.29c-1.22,1.9-6.71,12.19-12.3,23.06-3.64,7.06-6.67,13.06-6.96,13.78-1.1,2.7-1.22,5.69-.32,8.47,.73,2.19,2.1,4.11,3.94,5.5,1.38,.89,2.94,1.45,4.56,1.64,.61,.09,1.86,.1,19.22,.1s18.62,0,19.22-.1c1.62-.19,3.18-.75,4.56-1.64,1.84-1.39,3.21-3.31,3.94-5.5,.81-2.5,.8-5.2-.05-7.69-.53-1.57-3.72-8.4-9.03-19.36-4.08-8.41-6.23-12.91-7.95-16.7l-.82-1.81V5.34l1.42-1.42c0-2.79,.28-3.54-10.38-3.54-11.12,0-10.28,.49-10.28,3.54Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.88,
    y1: 1049.27,
    x2: 1.64,
    y2: 1047.53,
    gradientTransform: "translate(-51.96 58242.64) scale(55.56 -55.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e5e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.79,
    y1: 1047.72,
    x2: 1.22,
    y2: 1049.02,
    gradientTransform: "translate(-37.81 51869.32) scale(44.94 -49.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c1c4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.44,
    cy: 29.5,
    r: 4.1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.79,
    y1: 1068.7,
    x2: 1.54,
    y2: 1066.95,
    gradientTransform: "translate(19.02 11235.12) scale(10.5 -10.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbf399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25b896"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.61,
    cy: 20.85,
    r: 1.82,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.63,
    y1: 1102.36,
    x2: 1.38,
    y2: 1100.61,
    gradientTransform: "translate(21.2 4826.68) scale(4.36 -4.36)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.88,
    cy: 33.6,
    r: 2.73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.74,
    y1: 1079.44,
    x2: 1.49,
    y2: 1077.69,
    gradientTransform: "translate(14.39 7848.24) scale(7.25 -7.25)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.58,
    cy: 20.85,
    r: 1.84,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.3,
    y1: 1080.74,
    x2: 1.8,
    y2: 1079.56,
    gradientTransform: "translate(14.39 7848.24) scale(7.25 -7.25)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.89,
    y1: 1049.76,
    x2: 1.63,
    y2: 1048.03,
    gradientTransform: "translate(-55.88 52507.04) scale(56.88 -50.03)",
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_23417"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gradient_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1914",
    x: 2.41,
    y: -1.69,
    width: 55.56,
    height: 55.56,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_4283"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.88,45.26H5.94V-4.19H50.88V45.26Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94-3.19V44.26H49.88V-3.19H6.94m-2-2H51.88V46.26H4.94V-5.19Z",
    fill: "#707071"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gradient_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1928",
    x: 28.33,
    y: 24.12,
    width: 10.5,
    height: 10.5,
    fill: "url(#linear-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gradient_1-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1929",
    x: 24.37,
    y: 18.73,
    width: 4.36,
    height: 4.36,
    fill: "url(#linear-gradient-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gradient_1-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1931",
    x: 20.45,
    y: 29.79,
    width: 7.25,
    height: 7.25,
    fill: "url(#linear-gradient-5)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gradient_1-4-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1931-2",
    x: 24.27,
    y: 18.28,
    width: 4.88,
    height: 4.88,
    fill: "url(#linear-gradient-6)"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_472",
    x1: 31.77,
    y1: 5.6,
    x2: 20.59,
    y2: 5.6,
    fill: "none",
    stroke: "#f4f4f5",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "_23417-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gradient_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    d: "M0,33.46s2.78,7.11,16.91,7.11,39.6-7.11,39.6-7.11v49.7H0V33.46Z",
    fill: "url(#linear-gradient-7)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIxLab);
export default __webpack_public_path__ + "static/media/ix-lab.5401b61413daf3abfc40f455506d803d.svg";
export { ForwardRef as ReactComponent };